import { InfoCircle } from 'assets/icons/InfoCircle';

import './styles.scss';

export const DisclaimerCard = () => {
  return (
    <div className="disclaimer-card">
      <div className="card-header">
        <InfoCircle />
        <p className="label">Disclaimer</p>
      </div>
      <div className="card-content">
        <p>
          We have made every effort to make this document accurate. However,
          it is for reference only. Images, technical diagrams, interior
          layouts and descriptive information are for illustration purposes
          only and are not actual information or a legal commitment. Official
          information is based on the Sale and Purchase Agreement. Apartment
          names and unit codes are for introduction purposes; the official
          apartment names and unit codes will be recorded in the Sale and
          Purchase Agreement.
        </p>
        <br />
        <p>
          <p className="label">Note</p>
          <p>
            The final usable area of the apartment will be verified by the surveying unit
          </p>
        </p>
      </div>
    </div>
  );
};
